import React__default from 'react';
import { message } from 'antd';
import CloseOutlined from './../../../external/@ant-design/icons/es/icons/CloseOutlined.js';
import CheckOutlined from './../../../external/@ant-design/icons/es/icons/CheckOutlined.js';
import WarningFilled from './../../../external/@ant-design/icons/es/icons/WarningFilled.js';

var SuccessMessageIcon = function SuccessMessageIcon() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '18px',
      height: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '8px',
      backgroundColor: '#32eb71',
      borderRadius: '100px'
    },
    className: "dm-message-info-icon"
  }, /*#__PURE__*/React__default.createElement(CheckOutlined, {
    style: {
      color: 'white',
      fontSize: '10px'
    }
  }));
};
var WarningMessageIcon = function WarningMessageIcon() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '18px',
      height: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '8px',
      backgroundColor: 'white',
      borderRadius: '100px'
    },
    className: "dm-message-info-icon"
  }, /*#__PURE__*/React__default.createElement(WarningFilled, {
    style: {
      color: '#fcdd3e',
      fontSize: '17px'
    }
  }));
};
var ErrorMessageIcon = function ErrorMessageIcon() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '18px',
      height: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '8px',
      backgroundColor: '#ff7d7d',
      borderRadius: '100px'
    },
    className: "dm-message-info-icon"
  }, /*#__PURE__*/React__default.createElement(CloseOutlined, {
    style: {
      color: 'white',
      fontSize: '10px'
    }
  }));
};
var MessageContent = function MessageContent(_ref) {
  var messageText = _ref.messageText,
    descriptionText = _ref.descriptionText,
    icon = _ref.icon,
    key = _ref.key;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "dm-message-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, icon, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "dm-message-message-text"
  }, messageText), /*#__PURE__*/React__default.createElement("div", {
    className: "dm-message-description-text"
  }, descriptionText))), /*#__PURE__*/React__default.createElement(CloseOutlined, {
    style: {
      color: '#bcbec6',
      fontSize: '10px',
      marginLeft: '8px'
    },
    onClick: function onClick() {
      return message.destroy(key);
    }
  }));
};
function DmMessage(props) {
  var messageText = props.messageText,
    descriptionText = props.descriptionText,
    type = props.type,
    duration = props.duration,
    key = props.key,
    className = props.className,
    style = props.style;
  var iconsMap = {
    error: /*#__PURE__*/React__default.createElement(ErrorMessageIcon, null),
    success: /*#__PURE__*/React__default.createElement(SuccessMessageIcon, null),
    warning: /*#__PURE__*/React__default.createElement(WarningMessageIcon, null)
  };
  var classMap = {
    error: 'dm-message-error',
    success: 'dm-message-success',
    warning: 'dm-message-warning'
  };
  return message.info({
    content: /*#__PURE__*/React__default.createElement(MessageContent, {
      icon: iconsMap[type],
      messageText: messageText,
      descriptionText: descriptionText,
      key: key
    }),
    icon: /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'none'
      }
    }),
    duration: duration,
    key: key,
    className: "dm-message dm-message-general ".concat(classMap[type], " ").concat(className),
    style: style
  });
}
DmMessage.defaultProps = {
  messageText: "",
  descriptionText: "",
  type: "success",
  duration: 5,
  key: "key",
  className: "",
  style: {}
};

export { DmMessage };
